import React from 'react'

import { Container, VipHeadline, VipSubHeadline, Title, Deal } from './styles'

const DiscountBanner = () => (
  <Container>
    <VipHeadline>VIP Early Access:</VipHeadline>
    <Title>$40 Off Calendar</Title>
    <VipSubHeadline>Use code VIPBTS at checkout</VipSubHeadline>
    <Deal>Ends 8/2 at 11:59pm PST or while supplies last.</Deal>
  </Container>
)

export default DiscountBanner
